import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import {ExpandMoreOutlined} from "@mui/icons-material";
import {DIVIDER, PD_LG, PD_MD, PD_SM} from "@/shared/dimens";
import {FaqSectionData} from "../../types";

export function FaqSection(props: { data: FaqSectionData }): ReactElement {
  return <SectionContainer>
    <StyledBoxColumn style={{gap: PD_SM}}>
      {props.data.title
        ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
        : null}
      {props.data.subtitle
        ? <Typography style={{opacity: 0.6}}>{props.data.subtitle}</Typography>
        : null}
    </StyledBoxColumn>
    <StyledBoxColumn style={{gap: 0, border: DIVIDER, borderRadius: PD_MD, overflow: "hidden"}}>
      {props.data.faqs.map((faq, i) =>
        <Accordion key={i} disableGutters style={{borderBottom: i < props.data.faqs.length - 1 ? DIVIDER : "none"}}>
          <AccordionSummary expandIcon={<ExpandMoreOutlined/>} style={{padding: `0 ${PD_LG}px`, minHeight: 64}}>
            <Typography style={{fontWeight: "bold", padding: `${PD_SM}px 0`}}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{padding: `0 ${PD_LG}px ${PD_LG}px`}}>
            <Typography style={{opacity: 0.7, lineHeight: 1.7}}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </StyledBoxColumn>
  </SectionContainer>;
}
